import firebase from "firebase";

export const app = firebase.initializeApp({
  apiKey: "AIzaSyBOklnnFIeqFHsFeUu-dyEtCR4sa_16-x0",
  authDomain: "codelab-learning-hub.firebaseapp.com",
  projectId: "codelab-learning-hub",
  storageBucket: "codelab-learning-hub.appspot.com",
  messagingSenderId: "225727299951",
  appId: "1:225727299951:web:7905bd7d0bc4f954e4a89a",
});

// apiKey: "AIzaSyBWoDtyW8XD5a-GKWbC1UFVkFt2uTDVPlI",
// authDomain: "our-first-projects.firebaseapp.com",
// projectId: "our-first-projects",
// storageBucket: "our-first-projects.appspot.com",
// messagingSenderId: "451475182274",
// appId: "1:451475182274:web:009a292ae0c530a393615b",
